import { getdhcpReservations, getDhcpReservationsFail, getDhcpReservationsLoading, getDhcpReservationsSuccess, setNewDHCPReservationsFail, setNewDHCPReservationsSuccess, setNewDHCPReservationsLoading } from '../actions';
import * as actionTypes from '../actions/actionTypes';

const initialState = {
    portForwardingStartedAt: null,
    showSpinner: false,
    showDeviceList: false,
    portForwardingError: null,
};

const setPortForwardingStartTime = (state, action) => ({
    ...state,
    portForwardingStartedAt: action.portForwardingStartedAt,
    showSpinner: true,
})

const portForwardingSuccess = (state, action) => ({
    ...state,
    showDeviceList: true,
    showSpinner: false,
})
 
const portForwardingFail = (state, action) => ({
    ...state,
    showSpinner: false,
    portForwardingError: action.portForwardingError,
})

const getDhcpReservations = (state, action) => ({
    ...state,
    dhcpList: action.payload,
})


const reducer = (state = initialState, action) => {
    switch (action.type) {
        case actionTypes.SET_PORT_FORWARDING_START_TIME:
            return setPortForwardingStartTime(state, action);
        case actionTypes.SET_PORT_FORWARDING_SUCCESS:
            return portForwardingSuccess(state, action);
        case actionTypes.SET_PORT_FORWARDING_FAIL:
            return portForwardingFail(state, action);
        case actionTypes.GET_DHCP_RESERVATIONS:
            return getDhcpReservations(state, action);
        case actionTypes.GET_DHCP_RESERVATIONS_SUCCESS:
            return getDhcpReservations(state, action);
        case actionTypes.GET_DHCP_RESERVATIONS_FAIL:
            return getDhcpReservationsFail(state, action);
        case actionTypes.GET_DHCP_RESERVATIONS_LOADING:
            return getDhcpReservationsLoading(state, action);
        case actionTypes.SET_NEW_DHCP_RESERVATIONS:
            return setNewDHCPReservations(state, action);
        case actionTypes.SET_NEW_DHCP_RESERVATIONS_LOADING:
            return setNewDHCPReservationsLoading(state, action);
        case actionTypes.SET_NEW_DHCP_RESERVATIONS_SUCCESS:
            return setNewDHCPReservationsSuccess(state, action);
         case actionTypes.SET_NEW_DHCP_RESERVATIONS_FAIL:
            return setNewDHCPReservationsFail(state, action);
        default:
            return state;
    }
};

export default reducer;
